import { message, notification } from "antd";
export const Success = messages => {
  notification.success({
    className: "success-title-message",
    message: "Success",
    description: messages,
    duration: 4 || null,
    placement: "bottomRight",
    showProgress: true,
    pauseOnHover: true
  });
};
export const Error = messages => {
  notification.error({
    className: "error-title-message",
    message: "Error",
    description: messages,
    duration: 4,
    placement: "bottomRight",
    showProgress: true,
    pauseOnHover: true
  });
};
export const Warning = messages => {
  notification.warning({
    className: "warning-title-message",
    message: "Warning",
    description: messages,
    duration: 4,
    placement: "bottomRight",
    showProgress: true,
    pauseOnHover: true
  });
};
